module.exports = __webpack_public_path__ + "assets/img/b288-sy.svg";